import React from 'react';
import PropTypes from 'prop-types';
import Surface from './Surface';
import Badge from './Badge';
import styles from './StatCard.module.css';

const StatCard = ({ title, value, delta, deltaLabel, tone = 'neutral', footer, icon }) => {
  return (
    <Surface padding="lg" className={styles.card} tone="glass">
      <div className={styles.header}>
        <div className={styles.titleGroup}>
          <span className={styles.title}>{title}</span>
          {delta && <Badge tone={tone === 'positive' ? 'success' : tone === 'negative' ? 'danger' : 'neutral'}>{delta}</Badge>}
        </div>
        {icon && <div className={styles.icon}>{icon}</div>}
      </div>
      <div className={styles.value}>{value}</div>
      {deltaLabel && <p className={styles.deltaLabel}>{deltaLabel}</p>}
      {footer && <div className={styles.footer}>{footer}</div>}
    </Surface>
  );
};

StatCard.propTypes = {
  title: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  delta: PropTypes.string,
  deltaLabel: PropTypes.string,
  tone: PropTypes.oneOf(['neutral', 'positive', 'negative']),
  footer: PropTypes.node,
  icon: PropTypes.node
};

export default StatCard;
